export default __webpack_public_path__ + "static/media/invio_telematico_new.d19ec65e.png";